<template>
    <Head>
        <title>Wakaf Pahang - Sunting Projek</title>
        <link rel="shortcut apple-touch-icon icon" :href="img_favicon" type="image/png">
    </Head>
    <section ref="header" class="container-fluid py-3 position-fixed top-0 bg-wakaf-primary" style="z-index: 5">
        <div class="row">
            <h1 class="fs-3 text-center text-white" >Sunting Projek Wakaf</h1>
        </div>
    </section>
    <section ref="body" class="container-fluid">
        <div class="row">
            <div class="d-flex w-auto">
                <div class="d-flex align-items-center">
                    <Link replace class="btn btn-warning" :href="uri_main"><font-awesome-icon :icon="faChevronLeft" /></Link>
                </div>
                <div class="col-md-12 ms-2">
                    <div class="d-flex flex-column">
                        <span class="fs-4 fw-bold">Sunting projek wakaf</span>
                        <span class="fs-6">Sunting maklumat yang perlu sahaja </span>
                        <span v-if="!isEmpty($page.props.errors)" class="fs-6 text-danger fw-bold mt-3">Sila penuhi syarat berikut: </span>
                        <ul v-if="!isEmpty($page.props.errors)" class="fs-6 text-danger fw-bold">
                            <li v-for="error in $page.props.errors">{{ error }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="row justify-content-center">
                <form @submit.prevent="formSend">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="mb-3">
                                <label for="namaProjek" class="form-label">Nama Projek</label>
                                <input type="text" class="form-control" id="namaProjek" v-model="editProjekWakaf.nama" placeholder="Nama Projek">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-3">
                                <label for="district" class="form-label">Daerah Projek</label>
                                <select class="form-select" id="district" v-model="editProjekWakaf.district">
                                    <option selected disabled value="0">Sila pilih</option>
                                    <option v-for="projek in daerah" :value="projek.KodDaerah">{{ projek.daerah }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-3">
                                <label for="susunan" class="form-label">Susunan</label>
                                <input type="number" min="10" class="form-control" v-model="editProjekWakaf.susunan" id="susunan" placeholder="Susunan">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-3">
                                <label for="jumlahKutipan" class="form-label">Jumlah Kutipan (RM)</label>
                                <input type="number" min="0" class="form-control" v-model="editProjekWakaf.jumlahKutip" id="jumlahKutipan" placeholder="Jumlah (RM)">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="mb-3">
                                <label for="jumlahDigunakan" class="form-label">Jumlah Digunakan (RM)</label>
                                <input type="number" min="0" class="form-control" v-model="editProjekWakaf.jumlahGuna" id="jumlahDigunakan" placeholder="Jumlah (RM)">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-3">
                                <label for="sasaran" class="form-label">Sasaran (RM)</label>
                                <input type="number" min="0" class="form-control" v-model="editProjekWakaf.sasaran" id="sasaran" placeholder="Sasaran (RM)">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-3">
                                <label for="baki" class="form-label">Baki (RM)</label>
                                <input type="number" min="0" class="form-control" v-model="editProjekWakaf.baki" id="baki" placeholder="Baki (RM)">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-3">
                                <label class="form-label">Tarikh mula</label>
                                <VueDatePicker v-model="editProjekWakaf.dateFrom" :auto-position="true"
                                               :time-config="{ enableTimePicker: false }" :formats="{ input: 'dd-MMM-yyyy', preview: 'dd-MMM-yyyy' }" week-start="0" :locale="ms" :format-locale="ms"
                                               placeholder="Tarikh mula" select-text="Pilih" cancel-text="Tutup" class="w-100"></VueDatePicker>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="mb-3">
                                <label class="form-label">Tarikh tamat</label>
                                <VueDatePicker v-model="editProjekWakaf.dateTo" :auto-position="true"
                                               :time-config="{ enableTimePicker: false }" :formats="{ input: 'dd-MMM-yyyy', preview: 'dd-MMM-yyyy' }" week-start="0" :locale="ms" :format-locale="ms"
                                               placeholder="Tarikh tamat" select-text="Pilih" cancel-text="Tutup" class="w-100"></VueDatePicker>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <button type="submit" :disabled="isSending" class="btn btn-primary float-end"><font-awesome-icon :icon="faRotate" /> Kemaskini</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import {onMounted, Ref, ref} from "vue";
import {Head, Link, router} from "@inertiajs/vue3";
import { RequestPayload } from "@inertiajs/core";
import { ms } from "date-fns/locale";
import { VueDatePicker } from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import {formatISO} from "date-fns";
import Swal from "sweetalert2";
import {faChevronLeft, faRotate} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
library.add(faChevronLeft);
library.add(faRotate);

const data = defineProps<{
    csrf: string,
    img_favicon: string,
    uri_main: string,
    projekWakafEdit: Data,
    uri_update: string,
    daerah: {
        KodDaerah: number,
        daerah: string
    }[],
}>();

const header: Ref = ref<HTMLDivElement>();
const body: Ref = ref<HTMLDivElement>();
const isSending: Ref = ref<boolean>(false);

interface Data{
    kod: number,
    nama: string,
    SasaranKutipan: number,
    JumlahKutipan: number,
    JumlahDigunakan: number,
    BakiKutipan: number,
    TarikhMula: string,
    TarikhAkhir: string,
    Susunan: number,
    DaerahID: number,
}

const editProjekWakaf: Ref = ref<{
    nama: string,
    district: number,
    susunan: number | null,
    jumlahGuna: number | null,
    jumlahKutip: number | null,
    sasaran: number | null,
    baki: number | null,
    dateFrom: string | null,
    dateTo: string | null,
}>({
    nama: "",
    district: 0,
    susunan: null,
    jumlahGuna: null,
    jumlahKutip: null,
    sasaran: null,
    baki: null,
    dateFrom: null,
    dateTo: null,
});

onMounted(() => {
    body.value.style.marginTop = header.value.clientHeight+10 +"px";
    window.addEventListener("resize", ()=>{
        body.value.style.marginTop = header.value.clientHeight+10 +"px";
    });
    editProjekWakaf.value.nama = data.projekWakafEdit.nama;
    editProjekWakaf.value.district = data.projekWakafEdit.DaerahID;
    editProjekWakaf.value.susunan = data.projekWakafEdit.Susunan;
    editProjekWakaf.value.jumlahKutip = data.projekWakafEdit.JumlahKutipan;
    editProjekWakaf.value.jumlahGuna = data.projekWakafEdit.JumlahDigunakan;
    editProjekWakaf.value.sasaran = data.projekWakafEdit.SasaranKutipan;
    editProjekWakaf.value.baki = data.projekWakafEdit.BakiKutipan;
    editProjekWakaf.value.dateFrom = data.projekWakafEdit.TarikhMula;
    editProjekWakaf.value.dateTo = data.projekWakafEdit.TarikhAkhir;

});

const formSend = (): void => {
    if(!formValidation()){
        Swal.fire({
            position: "center",
            icon: "error",
            title: "Maklumat tidak sah atau lengkap",
            showConfirmButton: true,
            confirmButtonText: "Ok"
        });
        return;
    }
    let postData: {
        nama: string,
        district: number,
        susunan: number,
        jumlahGuna: number,
        jumlahKutip: number,
        sasaran: number,
        baki: number,
        dateFrom: string,
        dateTo?: string,
    } = {
        nama: editProjekWakaf.value.nama,
        district: editProjekWakaf.value.district,
        susunan: editProjekWakaf.value.susunan,
        jumlahGuna: editProjekWakaf.value.jumlahGuna,
        jumlahKutip: editProjekWakaf.value.jumlahKutip,
        sasaran: editProjekWakaf.value.sasaran,
        baki: editProjekWakaf.value.baki,
        dateFrom: formatISO(new Date(editProjekWakaf.value.dateFrom))
    };
    if(editProjekWakaf.value.dateTo !== null){
        postData = { ... postData, dateTo: formatISO(new Date(editProjekWakaf.value.dateTo))};
    }

    //const formProjek = postData as unknown;
    router.patch(data.uri_update, postData as RequestPayload,{
        onError: () => {
            //page
            isSending.value = false;
            //console.log(page);
        }
    });
}

const formValidation = (): boolean =>{
    let isPassValidation: boolean = true;
    if(editProjekWakaf.value.nama === "" || editProjekWakaf.value.nama.length < 10 || editProjekWakaf.value.nama.length > 140){
        isPassValidation = false;
    }
    if(editProjekWakaf.value.district === 0){
        isPassValidation = false;
    }``
    if(editProjekWakaf.value.jumlahKutip >= 100000000 || editProjekWakaf.value.jumlahKutip <= 0){
        isPassValidation = false;
    }
    if(editProjekWakaf.value.jumlahGuna >= 100000000 || editProjekWakaf.value.jumlahGuna < 0){
        isPassValidation = false;
    }
    if(editProjekWakaf.value.sasaran >= 100000000 || editProjekWakaf.value.sasaran <= 0){
        isPassValidation = false;
    }
    if(editProjekWakaf.value.baki >= 100000000 || editProjekWakaf.value.baki < 0){
        isPassValidation = false;
    }
    if(editProjekWakaf.value.dateFrom === null || editProjekWakaf.value.dateFrom === "") {
        isPassValidation = false;
    }
    // Date to is not validated here due to unknown end date by default

    return isPassValidation;
}

const isEmpty = (obj: Object): boolean => {
    return Object.keys(obj).length === 0;
}

</script>

<style scoped>

</style>
